import React, { useMemo } from "react";
import { ReactComponent as Logo } from "@iso/assets/images/logo.svg";
import LogoIppudoLoading from "@iso/assets/images/logo_ipp/loading_logo_ipp.gif";
import { useHistory } from "react-router-dom";

function LoadingLogo() {
   const { location } = useHistory();

   const isPageIppudo = useMemo(() => {
      return location?.pathname?.toLowerCase()?.includes("ippudo");
   }, [location?.pathname]);

   return isPageIppudo ? (
      <div className="loading-routes w-screen h-screen bg-red-600 flex items-center justify-center">
         <div>
            <img src={LogoIppudoLoading} width={130} alt="" />
         </div>
      </div>
   ) : (
      <div className="loading-routes w-screen h-screen bg-primary-500 flex items-center justify-center">
         <div className="animate-bounce">
            <Logo />
         </div>
      </div>
   );
}

export default LoadingLogo;
